export const FETCHING_PLAYER_INFO_REQUEST = 'clan/FETCHING_PLAYER_INFO_REQUEST';
export const FETCHING_PLAYER_INFO_FAILURE = 'clan/FETCHING_PLAYER_INFO_FAILURE';
export const FETCHING_PLAYER_INFO_SUCCESS = 'clan/FETCHING_PLAYER_INFO_SUCCESS';
